import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { SEOHead } from "../components/SEOHead";
import { Sidebar } from "../components/Layout";
import { CoverageMap } from "../components/CoverageMap";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GeoListPage({ navPages }) {
  const [pages, setPages] = useState([]);
  const [zipPages, setZipPages] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([axios.get(`${API}/geo/pages`).catch(() => ({ data: [] })), axios.get(`${API}/geo/zip-pages`).catch(() => ({ data: [] }))]).then(([p, z]) => { setPages(p.data); setZipPages(z.data); }).finally(() => setLoading(false));
  }, []);
  const zipsByCity = {};
  zipPages.forEach(z => { if (!zipsByCity[z.city]) zipsByCity[z.city] = []; zipsByCity[z.city].push(z); });
  return (
    <div data-testid="geo-list-page">
      <SEOHead title="DFW House Cleaning Service Areas & Cities" description="Lazy Days Home Services provides professional house cleaning across the DFW metroplex. See every city and ZIP code we serve — Arlington, Fort Worth, Mansfield & more." keywords="dfw house cleaning, arlington cleaning service, mansfield maid service, service areas texas" />
      <div className="page-header"><h1>Our Service Areas</h1></div>
      <div className="main-layout"><div className="main-content"><div className="content-panel">
        <p style={{ fontSize: "1.05rem", marginBottom: 24, lineHeight: 1.7, color: "#444" }}>Lazy Days Home Services proudly serves homeowners across the Dallas-Fort Worth metroplex. Click on your city or ZIP code below to learn more about our cleaning services in your area.</p>
        {!loading && pages.length > 0 && (
          <div style={{ marginBottom: 28 }} data-testid="coverage-map-section">
            <h2 style={{ marginBottom: 6 }}>Where We Clean Across DFW</h2>
            <p style={{ color: "#555", marginBottom: 12 }}>Explore our full house cleaning coverage area — click any pin to jump to that city's page.</p>
            <CoverageMap cities={pages} />
          </div>
        )}
        {loading ? <div className="loading-spinner"></div> : (
          <div data-testid="geo-city-list">{pages.map(p => (
            <div className="geo-city-block" key={p.slug} data-testid={`geo-block-${p.slug}`}>
              <div className="geo-city-block-header"><Link to={`/service-areas/${p.slug}`} className="geo-city-block-title"><i className="fa fa-map-marker"></i> {p.city}, {p.state}</Link>{p.distance_miles > 0 && <span className="geo-city-dist">{p.distance_miles} mi from Arlington</span>}</div>
              {zipsByCity[p.city] && zipsByCity[p.city].length > 0 && (<div className="geo-zip-tags">{zipsByCity[p.city].map(z => (<Link to={`/service-areas/${z.slug}`} className="geo-zip-tag" key={z.zip} data-testid={`zip-tag-${z.zip}`}>{z.zip}</Link>))}</div>)}
            </div>
          ))}</div>
        )}
        <div className="geo-cta-box" data-testid="geo-cta-box"><h2>Don't see your area?</h2><p>We may still serve your area! Call us at <a href="tel:8172777387">(817) 277-7387</a> or <Link to="/Contact-Us">contact us</Link> to check availability.</p></div>
      </div></div><Sidebar navPages={navPages} /></div>
    </div>
  );
}
